import DataListBulkActionsContext from "@magicware/data-lists/DataListBulkActionsContext";
import { MenuAction } from "@magicware/data-lists/DataListContextMenu";
import { useTranslation } from "react-i18next";
import { useNewItemMenuAction } from "../../navigation/hooks";
import { useLibraryId, useLibraryVersionId } from "../../navigation/libraries";

export default function ConnectorImplementationListMenuContext(props: { children?: React.ReactNode }) {
    const { t } = useTranslation();
    const actions: MenuAction[] = [];
    const libraryId = useLibraryId();
    const libraryVersionId = useLibraryVersionId();
    const addAction = useNewItemMenuAction(t("add-connectorImplementation"), (n) =>
        n.libraries.detail.versions.detail.connectors.new.url(libraryId, libraryVersionId),
    );
    return (
        <DataListBulkActionsContext defaultAction={addAction} actions={actions}>
            {props.children}
        </DataListBulkActionsContext>
    );
}
